module.exports = __webpack_public_path__ + "img/doc-ad1-lg.f763a996.jpg";